import { Modal, ModalFooter, ModalHeader, ModalTitle } from 'react-bootstrap';
import { useState, useEffect } from "react";
import CertificateService from "../../Services/CertificateService";
import LoadingIndicator from "../CommonComponent/LoadingIndicator";
import { ReactComponent as AddIcon } from '../../Assets/img/AddIcon.svg';
import { ReactComponent as Error } from '../../Assets/img/Error.svg';

/**
 * Renders Generate CSR pop up to generate a Certificate Signing Request for the selected tenant
 * @component
 * @param {string} props.keyType Which of the partner's HSM keys to use ("Device" or "Ftm")
 * @param {Event} props.onClose() To close pop up
 * @param {Event} props.onShowMessage("message") To show message in pop up
 */
function GenerateCSR(props) {
    const [error, setError] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [partnerDetails, setPartnerDetails] = useState(null);

    const fileName = `Partner_${props.keyType}.csr`;

    /**
    * Calls certificate service to fetch the selected tenant's partner details
    * Runs only on the first render
    */
    useEffect(() => {
        CertificateService.getPartnerDetails().then((response) => {
            if (response.response != null) {
                setPartnerDetails(response.response);
            }
        }).catch(() => { });
    }, [])

    function generateCSRHandler(event) {
        event.preventDefault();
        setIsLoading(true);

        CertificateService.generateCSR(props.keyType)
            .then((response) => {
                setIsLoading(false);
                if (response.response == null) {
                    setError(response.errors[0].message);
                }
                else {
                    var FileSaver = require('file-saver');
                    var blob = new Blob([response.response]);
                    FileSaver.saveAs(blob, fileName);
                    props.onClose();
                    props.onShowMessage("Generated Sucessfully");
                }
            })
            .catch((err) => {
                setIsLoading(false);
                setError(err.response?.data?.errors?.[0]?.message || "Failed to generate CSR.");
            });
    }

    return (
        <Modal centered={true} show={true} onHide={props.onClose}>
            <ModalHeader style={{ border: "none" }} closeButton>
                <ModalTitle className="Header">
                    <strong>Generate {props.keyType} Certificate Signing Request</strong>
                </ModalTitle>
            </ModalHeader>
            <Modal.Body style={{ padding: '3%' }}>
                {isLoading ? (
                    <LoadingIndicator size="large" message="Generating..." />
                ) : (
                    <>
                        {error && (
                            <div className="alert alert-warning"><Error /><span className="message-popup-title">{error}</span></div>
                        )}
                        <p>Generate a {props.keyType} Certificate Signing Request for this partner using the HSM-held key. The CSR will be downloaded as <strong>{fileName}</strong>.</p>
                        {partnerDetails && (
                            <table className="table">
                                <tbody>
                                    <tr>
                                        <td><strong>State</strong></td>
                                        <td>{partnerDetails.State}</td>
                                    </tr>
                                    <tr>
                                        <td><strong>Locality</strong></td>
                                        <td>{partnerDetails.Locality}</td>
                                    </tr>
                                    <tr>
                                        <td><strong>Organization Name</strong></td>
                                        <td>{partnerDetails.OrganizationName}</td>
                                    </tr>
                                    <tr>
                                        <td><strong>Common Name</strong></td>
                                        <td>{partnerDetails.CommonName}</td>
                                    </tr>
                                </tbody>
                            </table>
                        )}
                    </>
                )}
            </Modal.Body>
            <ModalFooter style={{ border: "none" }}>
                <button type="button" className="primary-button" onClick={generateCSRHandler} disabled={isLoading}>
                    <span className="primary-button-icon"><AddIcon /></span>
                    <span className="primary-button-text">Generate CSR</span>
                </button>
            </ModalFooter>
        </Modal>
    );
}
export default GenerateCSR;
